import Component from 'D:/HBuilderProjects/园博园/uni_modules/uni-badge/components/uni-badge/uni-badge.vue'
wx.createComponent(Component)